export default "__VITE_ASSET__DtQUm9zi__"